import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addressType", "jobsiteSelect"]

  connect() {
    console.log('Quote recipient address controller connected')
    this.changeAddressType()
  }

  changeAddressType() {
    const addressType = this.addressTypeTarget.value
    console.log('Address type changed to:', addressType)
    
    if (addressType === 'jobsite') {
      this.jobsiteSelectTarget.style.display = 'block'
    } else {
      this.jobsiteSelectTarget.style.display = 'none'
    }
  }
}
